import { useEffect, useState } from "react";
import { useParams } from "react-router";
import Chart from "react-apexcharts";
import { apiFetch } from "@/service/api";

interface Movimiento {
  id: number;
  tipo: number;
  valor: number;
  createdAt: string;
}

export default function GraficoMovimiento() {
  const { id: proyecto_id } = useParams();
  const [movimientos, setMovimientos] = useState<Movimiento[]>([]);
  const [loading, setLoading] = useState(true);

  async function fetchMovimientos() {
    try {
      const res = await apiFetch(`movimientos/proyecto/${proyecto_id}`);
      if (res.ok) {
        const data = await res.json();
        setMovimientos(data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchMovimientos();
  }, [proyecto_id]);

  const sorted = [...movimientos].sort(
    (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
  );
  let balance = 0;
  const candles = sorted.map((m) => {
    const open = balance;
    if (m.tipo === 1) balance += m.valor;
    else balance -= m.valor;
    const close = balance;
    const high = Math.max(open, close);
    const low = Math.min(open, close);
    return { x: new Date(m.createdAt), y: [open, high, low, close] };
  });

  const series = [{ data: candles }];
  const options: any = {
    chart: { type: "candlestick", height: 400, background: "#ffffff" },
    theme: { mode: "light" },
    title: {
      text: "Balance del Proyecto",
      align: "center",
      style: { fontSize: "20px", color: "#111827" },
    },
    xaxis: { type: "datetime", labels: { style: { colors: "#374151" } } },
    yaxis: {
      tooltip: { enabled: true },
      labels: { style: { colors: "#374151" } },
    },
    grid: { borderColor: "#e5e7eb" },
  };

  return (
    <div>
      <div className="min-h- rounded-2xl border border-gray-200 bg-white px-6 py-10 dark:border-gray-800 dark:bg-white/[0.03]">
        {loading ? (
          <div className="text-center py-10">Cargando grafico...</div>
        ) : (
          <Chart
            options={options}
            series={series}
            type="candlestick"
            height={400}
          />
        )}
      </div>
    </div>
  );
}
